import MuiCssBaseline from "@mui/material/CssBaseline";

export default function CssBaseline(props) {
  return <MuiCssBaseline {...props} />;
}
